import script from "./MemberSourceSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberSourceSelector.vue?vue&type=script&setup=true&lang=js"

import "./MemberSourceSelector.vue?vue&type=style&index=0&id=c4b69616&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4b69616"]])

export default __exports__